import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-common-dropdown',
  templateUrl: './common-dropdown.component.html',
  styleUrls: ['./common-dropdown.component.scss']
})
export class CommonDropdownComponent implements OnInit,OnDestroy {
  actions: any[];
  type = new FormControl("");
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CommonDropdownComponent>,
  ) {}

  ngOnInit(): void {
    this.data.options?.forEach((el) => {
      if (el.name == this.data.selectedType) {
        this.type.setValue(el.id);
      }
    });
    this.actions = this.data.actions || [
      { text: "Cancel", buttonStyle: "underline" },
      { text: "Confirm" },
    ];
  }

  close(e?) {
    if (e == "Confirm") {
      let selectedType = this.data.options?.filter(
        (res) => res.id == this.type.value
      );
      this.data.callBackFn(this.dialogRef, this.actions, selectedType);
    } else {
      this.dialogRef.close();
    }
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
